import React, { Component } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/logo1.png";
import { MenuItems } from "./MenuItems";
import "../styles/NavbarStyles.css";


class Navbar extends Component {
  state = { scrolled: false, clicked: false };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const scrollTop = window.scrollY;
    this.setState({ scrolled: scrollTop > 0 });
  };

  handleClick = () => {
    this.setState({ clicked: !this.state.clicked });
  };

  render() {
    const { scrolled, clicked } = this.state;

    return (
      <div className="noselect">
      <nav className={`NavbarItems ${scrolled ? "scrolled" : ""}`}>
        <div className="navbar-logo">
          <Link to="/">
            <img src={logo} alt="Logo Simcor" />
          </Link>
        </div>

        <div className="menu-icons" onClick={this.handleClick}>
          <i className={clicked ? "fas fa-times" : "fas fa-bars"}></i>
        </div>

        <ul className={clicked ? "nav-menu active" : "nav-menu"}>
          {MenuItems.map((item, index) => {
            return (
              <li key={index}>
                <Link className={item.cName} to={item.url}>
                  <hr/>
                  {item.title === "Inicio" && <i className="spaceicon fas fa-home"></i>}
                  {item.title === "Nosotros" && <i className="spaceicon fas fa-user"></i>}
                  {item.title === "Servicios" && <i className="spaceicon fas fa-toolbox"></i>}
                  {item.title}
                </Link>
              </li>
            );
          })}
          <span>
             <Link to="https://wa.me/3515291902?text=Hola me comunico a través de la pagina web, me interesan tus servicios">
              <button className="button-connect">
                  <span>Contactate</span>
              </button>
            </Link>
          </span>
        </ul>
      </nav>
      </div>
    );
  }
}

export default Navbar;
